import { of } from 'rxjs';
import { firestore } from '../../../functions/firebase/firebaseAccess';
import {
  collectionQuery,
  WithID,
} from '../../../functions/firebase/rxfireExtensions';
import { useObservable } from '../../../functions/hooks/useObservable';
import { isSeller } from '../../../functions/models/profiles';
import { Profile } from '../../../models/ClientModels';

export const useInventoryListingCount = (
  profile: WithID<Profile>,
  limit: number,
  ignored?: boolean,
) => {
  const storeId = profile.id;
  const isSellerProfile = isSeller(profile);
  const listings = useObservable(
    () =>
      isSellerProfile && !ignored
        ? collectionQuery(
            firestore()
              .collection('stores')
              .doc(storeId)
              .collection('listings')
              .limit(Math.max(1, limit)),
          )
        : of(undefined),
    `store:${storeId}:recent-${limit}-inventory-listings${
      ignored ? ':ignored' : ''
    }`,
  );
  return listings?.size ?? 0;
};
